import { NgModule } from '@angular/core';
import { MatLegacyListModule as MatListModule } from '@angular/material/legacy-list';
import { MatLegacyMenuModule as MatMenuModule } from '@angular/material/legacy-menu';
import { MatSidenavModule } from '@angular/material/sidenav';

import { ReportFormModule } from '@app/src/app/components/Form/ReportForm';
import { LogoModule } from '@app/src/app/components/Logo';
import { NavbarModule } from '@app/src/app/components/Navbar';
import { NavfillModule } from '@app/src/app/components/Navfill';
import { NaviconModule } from '@app/src/app/components/Navicon';
import { NavsearchModule } from '@app/src/app/components/Navsearch';
import { PersonAvatarModule } from '@app/src/app/components/PersonAvatar';
import { ContentViewsModule } from '@app/src/app/content-views';
import { MgDirectivesModule } from '@app/src/app/directives';
import { FileModule } from '@app/src/app/file';
import { FtueHighlightPipeModule } from '@app/src/app/ftue/Highlight/pipes/FtueHighlight';
import { GroupsModule } from '@app/src/app/groups/groups.module';
import { ScrollTargetDirectiveModule } from '@app/src/app/misc/ScrollTarget/directive';
import { TopNavModule } from '@app/src/app/navigation/components/TopNav';
import { ContentNavModule } from '@app/src/app/navigation/containers/ContentNav';
import { SideNavModule } from '@app/src/app/navigation/containers/SideNav';
import { AboutUsModule } from '@app/src/app/overlays/AboutUs';
import { PermissionsModule } from '@app/src/app/permissions';
import { MainFeedModule } from '@app/src/app/routes/MainFeed';
import { SearchProvidersModule } from '@app/src/app/search';
import { SearchContentModule } from '@app/src/app/search-content';
import { SearchOverlayModule } from '@app/src/app/search-overlay';
import { NotificationStoreModule } from '@app/src/app/store/Notifications';

import { GlobalSearchModule } from '@modules/global-search';

import { GenericModule } from '@shared/components/generic';
import { LayoutHeaderModule } from '@shared/components/layout-header';
import { NavigationModule } from '@shared/components/navigation/navigation.module';
import { CommonFormModules, CommonUIModules } from '@shared/modules';
import { ArrayPipesModule } from '@shared/pipes';

import { LayoutAccessDeniedComponent } from './components/layout-access-denied/layout-access-denied.component';
import { LayoutGlobalMenuComponent } from './components/layout-global-menu/layout-global-menu.component';
import { LayoutLegacyRootComponent } from './components/layout-legacy-root/layout-legacy-root.component';
import { LayoutLegacyComponent } from './components/layout-legacy/layout-legacy.component';
import { LayoutPageNotFoundComponent } from './components/layout-page-not-found/layout-page-not-found.component';
import { LayoutPrimaryMobileNavComponent } from './components/layout-primary-mobile-nav/layout-primary-mobile-nav.component';
import { LayoutPrimaryNavComponent } from './components/layout-primary-nav/layout-primary-nav.component';
import { LayoutSecondaryBreadcrumbComponent } from './components/layout-secondary-breadcrumb/layout-secondary-breadcrumb.component';
import { LayoutServerErrorComponent } from './components/layout-server-error/layout-server-error.component';
import { CheckNavigationDirective } from './directives';
import { LayoutComponent } from './layout.component';
import { CheckNavigationPermissionPipe } from './pipes';
import { RevHeroService } from '../../services/RevHero';

@NgModule({
  imports: [
    // Common modules
    CommonUIModules,
    CommonFormModules,

    // Minga dependencies
    LayoutHeaderModule,
    SearchOverlayModule,
    GenericModule,
    PermissionsModule,
    MgDirectivesModule,
    PersonAvatarModule,
    SearchContentModule,
    ReportFormModule,
    NavsearchModule,
    NaviconModule,
    NavfillModule,
    MainFeedModule,
    NavbarModule,
    SearchProvidersModule,
    GroupsModule,
    NotificationStoreModule,
    SideNavModule,
    FileModule,
    ContentViewsModule,
    TopNavModule,
    FtueHighlightPipeModule,
    ContentNavModule,
    LogoModule,
    NavigationModule,
    ArrayPipesModule,
    GlobalSearchModule,
    ScrollTargetDirectiveModule,
    AboutUsModule,

    // External dependencies
    MatMenuModule,
    MatSidenavModule,
    MatListModule,
    MatSidenavModule,
  ],
  declarations: [
    // Pipes
    CheckNavigationPermissionPipe,

    // Directives
    CheckNavigationDirective,

    // Components
    LayoutComponent,
    LayoutPrimaryNavComponent,
    LayoutPrimaryMobileNavComponent,
    LayoutLegacyComponent,
    LayoutSecondaryBreadcrumbComponent,
    LayoutPageNotFoundComponent,
    LayoutAccessDeniedComponent,
    LayoutGlobalMenuComponent,
    LayoutServerErrorComponent,
    LayoutLegacyRootComponent,
  ],
  exports: [LayoutComponent, LayoutPageNotFoundComponent, LayoutAccessDeniedComponent],
  providers: [RevHeroService],
})
export class LayoutModule {}
